export default __webpack_public_path__ + "17.387e6b.svg";